"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestId = void 0;
let TestId = exports.TestId = /*#__PURE__*/function (TestId) {
  // One particular error notification snackbar component
  TestId["ErrorNotification"] = "error-notification";
  return TestId;
}({});
